
taxes.classy.controller({
    name: 'TaxEmailModalController',
    inject: ['$scope', '$http', 'email', '$sce', 'authServiceFactory', '$modalInstance', 'FamilyTaxModelService'],
    init: function()
    {
        this.$.$sce = this.$sce;
        this.$.email = this.email[0].data[0];
        this.$.email.body = nl2br(this.$.email.body);
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory;

        var edate = this.$.email.date.split("-");
        this.$.emaildate = edate[1] + "/" + edate[2] + "/" + edate[0];
    },
    submit: function(scope, instance, form)
    {
        this.$.email.date = moment().format('YYYY-MM-DD');
        return this.FamilyTaxModelService.resend(this.$.email.familyID, this.$.email, instance);
    }
    
});


